import React from "react";
import { Button } from "@mui/material";
import { FaArrowLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const BackButton = () => {
  const navigate = useNavigate();

  return (
    <Button
      startIcon={<FaArrowLeft />}
      onClick={() => navigate("/dashboard")}
      sx={{
        mb: 2,
        textTransform: "none",
        fontWeight: 600,
        color: "text.primary",
        px: 1,
        py: 1,
        "&:hover": {
          backgroundColor: "action.hover",
        },
      }}
    >
      Back
    </Button>
  );
};

export default BackButton;